<template>
    <div>
        <filters
                class="white-container"
                :inputs="updatedFilters"
                @filter="filterContent"
                :extendButton="false"
                :extended="true"
                :filters="defaultSelected"
                :loading="tableLoading || loader"
        >
        </filters>
    </div>
</template>

<script>
    import filters from '@/components/global/filters';
    import {isEmpty, get, filter} from 'lodash';
    import { Event } from 'vue-tables-2';

    export default {
        props: {
            tableLoading: {
                type: Boolean,
                default: false
            },
            filters: {
                type: Array,
                default: () => ([])
            }
        },
        name: 'ContentConversionFilters',
        components: {
            filters,
        },
        data() {
            return {
                selectOptions: {
                    category: [],
                    author: [],
                    published: [],
                    order: []
                },
                loader: false,
                defaultSelected: {},
            }
        },

        computed: {
            updatedFilters() {
                if( !isEmpty(this.filters) ) {
                    this.filters.map( (filter) => {
                        filter.options = get(this.selectOptions, filter.response_object);
                    });
                }
                return this.filters;
            },
        },
        mounted() {
            this.getSelectOptions('content/analytics/filters');
            this.filters.map( (filter) => {
                if( !isEmpty(filter.defaultValue) ) {
                    this.defaultSelected[filter.name] = filter.defaultValue;
                }
            });
        },
        methods: {
            getSelectOptions(url, filters = {}) {
                this.loader = true;
                const params = {};
                params.filter = filters;
                try {
                    this.loader = true;
                    this.getData(url, {params: params}).then(({data}) => {
                        if (data) {
                            this.selectOptions.category = this.mapSelectOptions(data.category);
                            this.selectOptions.author = this.mapSelectOptions(data.author);
                            this.selectOptions.published = this.mapSelectOptions(data.published);
                            this.$forceUpdate();
                        }
                    })
                } catch (e) {
                    console.log(e)
                } finally {
                    this.loader = false;
                }
            },

            mapSelectOptions(options) {
                if( isEmpty(options) ) {
                    return [];
                }

                return filter(options, (item) => !!item.title).map(option => {
                    if (option.title && option.id) {
                        return {
                            label: option.title,
                            value: option.id
                        }
                    } else if (option.title) {
                        return {
                            label: option.title,
                            value: option.title
                        }
                    }
                });
            },

            filterContent(params) {
                this.params = params;
                Event.$emit('vue-tables.contentConversionTable.filter::custom', params);
                Event.$emit('vue-tables.contentConversionTableTotal.filter::custom', params);
                this.getSelectOptions('content/analytics/filters', params);
            },
        },
        destroyed() {
        },
    };
</script>